<template>
  <div :class="{'swipers':true,'swiperRight1':swiperR,'swiperDown1':swiperD,'swiperLeft':swiperL}">
    <div class="thumbs swiper-container"
         :id="Top"
         :class="{'swiperRight2':swiperR,'swiperDown2':swiperD}">
      <ul v-if="arr.length"
          class="clearfix swiper-wrapper">
        <template v-for="(ite,index) in arr">
          <li class="fl swiper-slide"
              :key="index"
              @click="slideshow($event,index,arr)"
              @contextmenu.stop.prevent="$emit('emitContextMenuItem',$event,ind,ite)"
              @touchstart="touchstarts($event,ind,ite)"
              @touchmove="touchmoves()"
              @touchend="touchends()">
            <ZImage :value="ite.standardData?ite.standardData:''"
                    :error-src="require('../../assets/image/images/default_media.png')" />
          </li>
        </template>
      </ul>
      <ul v-else
          class="clearfix swiper-wrapper">
        <li class="fl swiper-slide">
          <ZImage value=""
                  :error-src="require('../../assets/image/images/default_media.png')" />
        </li>
      </ul>
    </div>
    <div :class="{'swiperRight3':swiperR,'swiperDown3':swiperD}"></div>
    <div class="swiperDown"
         :class="{'swiperRight4':swiperR,'swiperDown4':swiperD}">
      <div class='arrow-left'
           :class="{'swiperRight':swiperR,'swiperDown':swiperD}"></div>
      <div class="detail-contents swiper-container"
           :id="Down"
           :class="{'swiperRight5':swiperR,'swiperDown5':swiperD}">
        <ul v-if="arr.length"
            class="clearfix swiper-wrapper">
          <template v-for="(ite,ind) in arr">
            <li class="fl swiper-slide"
                :key="ind"
                @contextmenu.stop.prevent="windowRightMenu($event,'1',ite)"
                @touchstart="touchstarts($event,ind,ite)"
                @touchmove="touchmoves()">
              <video :src="ite.standardData"
                     v-if="isVideo(ite.standardData)"
                     style="height:100%;max-width:100%"></video>
              <ZImage v-else
                      :value="ite.standardData?ite.standardData:''"
                      :error-src="require('../../assets/image/images/default_media.png')" />
            </li>
          </template>
        </ul>
        <ul v-else
            class="clearfix swiper-wrapper">
          <li class="fl swiper-slide">
            <ZImage value=""
                    :error-src="require('../../assets/image/images/default_media.png')" />
          </li>
        </ul>
      </div>
      <div class='arrow-right'
           :class="{'swiperRight':swiperR,'swiperDown':swiperD}"></div>
    </div>
  </div>
</template>
<script>
import ZImage from "../ZImage.vue"
import Bus from '../../bus.js'
export default {
  name: 'swipers',
  components: {
    ZImage
  },
  props: {
    sortTag: {
      type: Array,
      default: []
    },
    ind: String
  },
  data () {
    return {
      swiperR: '',
      swiperL: '',
      swiperD: 'true',
      direction: 'horizontal',
      arr: []
    }
  },
  mounted () {
    this.getSwiperDir(this.ind);
    var _this = this, arr = [];
    if (_this.sortTag[0] instanceof Array) {
      _this.sortTag[0].forEach((ite) => {
        if (_this.isPic(ite.standardData) || _this.isVideo(ite.standardData)) {
          arr.push(ite);
        }
      })
    } else {
      _this.sortTag.forEach((ite) => {
        if (_this.isPic(ite.standardData) || _this.isVideo(ite.standardData)) {
          arr.push(ite);
        }
      })
    }
    _this.arr = arr;
    Bus.$on('swiper', (t) => {
      if (t == _this.ind) {
        _this.getSwiperDir(_this.ind);
      }
    });
  },
  computed: {

    Top () {
      return 'Top' + this.ind;
    },
    Down () {
      return 'Down' + this.ind;
    }
  },
  methods: {
    touchstarts (ev, ind, ite) {
      var _this = this;
      // 长按事件触发
      clearTimeout(_this.timeOutEvent);
      _this.timeOutEvent = setTimeout(function () {
        _this.timeOutEvent = 0;
        _this.$emit('emitContextMenuItem', ev, ind, ite);
      }, 400);
      //长按400毫秒
      // e.preventDefault();
    },
    touchstarts (ev, ind, ite) {
      var _this = this;
      // 长按事件触发
      clearTimeout(_this.timeOutEvent);
      _this.timeOutEvent = setTimeout(function () {
        _this.timeOutEvent = 0;
        _this.handleContextmenu(ev, ind, ite);
      }, 400);
      //长按400毫秒
      // e.preventDefault();
    },
    touchmove: function () {
      clearTimeout(this.timeOutEvent);
      this.timeOutEvent = 0;
    },
    touchend: function (e) {
      clearTimeout(this.timeOutEvent);
      return false;
    },
    //是否为图片文件
    isPic (url) {
      if (url && typeof (url) == 'string' && url.indexOf('.png') > 0 || url && typeof (url) == 'string' && url.indexOf('.jpg') > 0) {
        return true;
      }
      return false;
    },
    swiperFn () {
      var mySwiper = new window.Swiper('#Down' + this.ind, {
        // paginationClickable: true,
        //解决初始化轮播不生效
        observer: true,
        observeParents: true,
        slidesPerView: 5,
        direction: this.direction,
        spaceBetween: 20,
        navigation: {
          nextEl: '.arrow-right',
          prevEl: '.arrow-left',
        }
      })
      var thumbs = new Swiper('#Top' + this.ind, {
        slidesPerView: 1,
        observer: true,
        observeParents: true,
        thumbs: {
          swiper: mySwiper
        }
      })
    },
    //图片轮播
    slideshow (e, ind, item) {
      e.preventDefault()
      var _this = this;
      var links = [], video = 0;
      item.forEach(function (items) {
        links.push(items.standardData);
        if (_this.isVideo(items.standardData)) {
          video = 1;
        }
      })
      if (video) {
        this.$router.push({ path: "slideshow", query: { video: JSON.stringify(links), ind: ind } });
      } else {
        this.$router.push({ path: "slideshow", query: { pictures: JSON.stringify(links), ind: ind } });
      }
    },
    //是否为视频文件
    isVideo (val) {
      var ty = false;
      if (val && val.indexOf('.mp4') > 0) {
        ty = true;
      }
      if (val && val.indexOf('.flv') > 0) {
        ty = true;
      }
      if (val && val.indexOf('.rmvb') > 0) {
        ty = true;
      }
      if (val && val.indexOf('.wmv') > 0) {
        ty = true;
      }
      if (val && val.indexOf('.avi') > 0) {
        ty = true;
      }
      if (val && val.indexOf('.mov') > 0) {
        ty = true;
      }
      if (val && val.indexOf('.rm') > 0) {
        ty = true;
      }
      return ty;
    },
    //寻找参数
    getQuery (name) {
      // 正则：[找寻'&' + 'url参数名字' = '值' + '&']（'&'可以不存在）
      let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      let r = window.location.search.substr(1).match(reg);//substr() 的参数指定的是子串的开始位置和长度
      if (r != null) {
        // 对参数值进行解码
        return decodeURI(r[2]);
      }
      return null;
    },
    //获取轮播图方向
    getSwiperDir (num) {
      var _this = this;
      _this.$http.get("/zciid-deliverable/showPlatformStyle/flow/api/detail/getTappByBlockId.json", {
        appId: this.$appId,
        blockId: this.getQuery('blockId'),
        sign: num
      }).then(res => {
        if (res.state == 1) {
          if (res.data.left == '1') {
            _this.swiperL = true;
            _this.swiperR = true;
            _this.swiperD = false;
            _this.direction = 'vertical';
          } else if (res.data.left == '2') {
            _this.swiperL = false;
            _this.swiperR = false;
            _this.swiperD = true;
            _this.direction = 'horizontal';
          } else if (res.data.left == '3') {
            _this.swiperL = false;
            _this.swiperR = true;
            _this.swiperD = false;
            _this.direction = 'vertical';
          }
        }
      }).then(() => {
        _this.$nextTick(() => {
          _this.swiperFn();
        })
      })
    },
  }
}
</script>
<style scoped>
.swiperLeft {
  flex-direction: row-reverse;
}
.swiperRight1 {
  width: 100%;
  height: 100%;
  display: flex;
}
.swiperDown1 {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.swiperRight2 {
  width: calc(100% - 73px);
  width: -moz-calc(100% - 73px);
  width: -webkit-calc(100% - 73px);
  width: -o-calc(100% - 73px);
  width: -ms-calc(100% - 73px);
  height: 100%;
}
.swiperDown2 {
  width: 100%;
  height: calc(100% - 73px);
  height: -moz-calc(100% - 73px);
  height: -webkit-calc(100% - 73px);
  height: -o-calc(100% - 73px);
  height: -ms-calc(100% - 73px);
}
.swiperRight3 {
  width: 15px;
  height: 100%;
}
.swiperDown3 {
  width: 100%;
  height: 30px;
}
.swiperRight4 {
  display: flex;
  align-items: center;
  height: 100%;
  width: 54px;
}
.swiperDown4 {
  display: flex;
  align-items: center;
  width: 100%;
}
.swiperRight5 {
  height: 100%;
}
.swiperDown5 {
  width: 100%;
}
.detail-contents.swiper-container.swiperRight5 li {
  width: 50px !important;
  background-color: #ededed;
}
.detail-contents.swiper-container.swiperDown5 li {
  height: 50px;
  background-color: #ededed;
}
.thumbs.swiper-container li {
  background-color: #ededed;
}
.detail-contents.swiper-container .swiper-slide-thumb-active {
  border: 2px solid red;
}
.detail-contents .swiper-wrapper {
  height: 100%;
  position: relative;
}
.swiperDown {
  position: relative;
}
.swiperDown .arrow-left.swiperRight {
  z-index: 9;
  width: 22px;
  height: 48px;
  position: absolute;
  top: 0;
  left: 30%;
  margin-top: -13px;
  transform: rotate(90deg);
  background: url("~@/assets/images/product_detail/recommend_arrow_left.png")
    no-repeat center;
  cursor: pointer;
}
.swiperDown .arrow-right.swiperRight {
  z-index: 9;
  width: 22px;
  height: 48px;
  position: absolute;
  bottom: 0;
  left: 30%;
  margin-bottom: -13px;
  transform: rotate(90deg);
  right: 0;
  background: url("~@/assets/images/product_detail/recommend_arrow_right.png")
    no-repeat center;
  cursor: pointer;
}
.swiperDown .arrow-left.swiperDown {
  z-index: 9;
  width: 22px;
  height: 48px;
  position: absolute;
  top: 50%;
  margin-top: -24px;
  left: 0;
  background: url("~@/assets/images/product_detail/recommend_arrow_left.png")
    no-repeat center;
  cursor: pointer;
}
.swiperDown .arrow-right.swiperDown {
  z-index: 9;
  width: 22px;
  height: 48px;
  position: absolute;
  top: 50%;
  margin-top: -24px;
  right: 0;
  background: url("~@/assets/images/product_detail/recommend_arrow_right.png")
    no-repeat center;
  cursor: pointer;
}
.swiper-slide {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
<style>
.swipers img {
  object-fit: contain !important;
}
</style>



// WEBPACK FOOTER //
// src/components/flowDetail/onlyswipers.vue